import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useCreateOffer from "./useCreateOffer";
import Select from "react-select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Style from "./createOffer.module.scss";

const CreateOffer = ({ isStickyFooter, closeModal, refetch }) => {
  const {
    formik,
    isEdit,
    isCustomOfferCreate,
    getFieldError,
    offersBasicData,
    handleTypeChange,
    handlePeriodChange,
    getMinEndDate,
    getMaxDate,
    handleCategoryChange,
    handleTransactionPeriodChange,
    splitedDiscountOptions,
  } = useCreateOffer(refetch, closeModal);

  return (
    <div className="row">
      <div className="input-wrap pro-mb-4">
        <Input
          label={"Offer Name"}
          type="text"
          id="name"
          name="name"
          className={`pro-input lg ${getFieldError("name") && "error"}`}
          {...formik.getFieldProps("name")}
          error={getFieldError("name")}
          errorMessage={getFieldError("name")}
        />
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Type
          </label>
          <Select
            id="offer_type"
            name="offer_type"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("offer_type") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.offer_types ?? []}
            value={
              offersBasicData?.data?.offer_types?.find(
                (item) => item?.id === formik?.values?.offer_type
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("offer_type")}
            onChange={(e) => handleTypeChange(e)}
            menuPlacement="auto"
          />
          {getFieldError("offer_type") && (
            <span className="error-text">{getFieldError("offer_type")}</span>
          )}
        </div>
        {formik.values.offer_type === 1 && (
          <>
            <Input
              label={"From Date"}
              type="date"
              id="start_date"
              name="start_date"
              className={`pro-input lg ${
                getFieldError("start_date") && " error"
              }`}
              {...formik.getFieldProps("start_date")}
              min={new Date().toISOString().split("T")[0]}
              max={getMaxDate()}
              error={getFieldError("start_date")}
              errorMessage={getFieldError("start_date")}
            />
            <Input
              label={"To Date"}
              type="date"
              id="end_date"
              name="end_date"
              className={`pro-input lg ${
                getFieldError("end_date") && " error"
              }`}
              {...formik.getFieldProps("end_date")}
              min={getMinEndDate()}
              disabled={formik?.values?.start_date === ""}
              error={getFieldError("end_date")}
              errorMessage={getFieldError("end_date")}
            />
          </>
        )}
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Period
          </label>
          <Select
            id="offer_period"
            name="offer_period"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("offer_period") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.offer_periods ?? []}
            value={
              offersBasicData?.data?.offer_periods?.find(
                (item) => item?.id === formik?.values?.offer_period
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("offer_period")}
            onChange={(e) => handlePeriodChange(e)}
            menuPlacement="auto"
          />
          {getFieldError("offer_period") && (
            <span className="error-text">{getFieldError("offer_period")}</span>
          )}
        </div>
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Category
          </label>
          <Select
            id="category_id"
            name="category_id"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("category_id") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.category ?? []}
            value={
              offersBasicData?.data?.category?.filter((item) =>
                formik?.values?.category_id?.includes(item?._id)
              ) || []
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            onBlur={formik.handleBlur("category_id")}
            onChange={(selected) => handleCategoryChange(selected)}
            menuPlacement="auto"
            isMulti={true}
          />
          {getFieldError("category_id") && (
            <span className="error-text">{getFieldError("category_id")}</span>
          )}
        </div>
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Product
          </label>
          <Select
            id="product_id"
            name="product_id"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("product_id") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.product ?? []}
            value={
              offersBasicData?.data?.product?.filter((item) =>
                formik?.values?.product_id?.includes(item?._id)
              ) || []
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            onBlur={formik.handleBlur("product_id")}
            onChange={(selected) => {
              const selectedIds = selected?.map((opt) => opt._id) || [];
              formik.setFieldValue("product_id", selectedIds);
              formik.setFieldValue("applicable_variant", []);
              formik?.setFieldValue("inclusion_type", "")
            }}
            menuPlacement="auto"
            isMulti={true}
          />
          {getFieldError("product_id") && (
            <span className="error-text">{getFieldError("product_id")}</span>
          )}
        </div>
        { formik?.values?.product_id?.length>0 &&  (
          <>
                  <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Product Variants
          </label>
          <Select
            id="applicable_variant"
            name="applicable_variant"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("applicable_variant") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.applicable_variants ?? []}
            value={
              offersBasicData?.data?.applicable_variants?.filter((opt) =>
                formik.values.applicable_variant?.includes(opt.name)
              ) || []
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("applicable_variant")}
            onChange={(value) =>
              formik.setFieldValue(
                "applicable_variant",
                value?.map((item) => item?.name) ?? []
              )
            }
            menuPlacement="auto"
            isMulti={true}
          />
          {getFieldError("applicable_variant") && (
            <span className="error-text">
              {getFieldError("applicable_variant")}
            </span>
          )}
        </div>
         <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Applicable Type
          </label>
          <Select
            id="inclusion_type"
            name="inclusion_type"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("inclusion_type") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.inclusion_types ?? []}
            value={
              offersBasicData?.data?.inclusion_types?.find(
                (item) => item?.id === formik?.values?.inclusion_type
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("inclusion_type")}
            onChange={(e) =>
              formik?.setFieldValue("inclusion_type", e?.id || "")
            }
            menuPlacement="auto"
          />
          {getFieldError("inclusion_type") && (
            <span className="error-text">
              {getFieldError("inclusion_type")}
            </span>
          )}
        </div>
      </>)}
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Store
          </label>
          <Select
            id="customer_key"
            name="customer_key"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("customer_key") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.store ?? []}
            value={
              offersBasicData?.data?.store?.filter((item) =>
                formik?.values?.customer_key?.includes(item?._id)
              ) || []
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            onBlur={formik.handleBlur("customer_key")}
            onChange={(selected) => {
              const selectedIds = selected?.map((opt) => opt._id) || [];
              formik.setFieldValue("customer_key", selectedIds);
            }}
            menuPlacement="auto"
            isMulti={true}
          />
          {getFieldError("customer_key") && (
            <span className="error-text">{getFieldError("customer_key")}</span>
          )}
        </div>
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Offer Day
          </label>
          <Select
            id="offer_day"
            name="offer_day"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("offer_day") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.offer_day ?? []}
            value={
              offersBasicData?.data?.offer_day?.filter((item) =>
                formik?.values?.offer_day?.includes(item?.id)
              ) || []
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("offer_day")}
            onChange={(selected) => {
              const selectedIds = selected?.map((opt) => opt.id) || [];
              formik.setFieldValue("offer_day", selectedIds);
            }}
            menuPlacement="auto"
            isMulti={true}
          />
          {getFieldError("offer_day") && (
            <span className="error-text">{getFieldError("offer_day")}</span>
          )}
        </div>
        <div className={`pro-mb-4 ${Style.time_wrap}`}>
          <div className={`pro-d-flex  ${Style.time_picker_wrap}`}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className={`${Style.time_item}`}>
                <label
                  htmlFor=""
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  From Hour
                </label>
                <TimePicker
                  value={formik.values.from_hour || null}
                  onChange={(newValue) => {
                    formik.setFieldValue("from_hour", newValue);
                  }}
                  className="time-picker"
                  disabled={formik.values.time_filter !== 1}
                />
                {getFieldError("from_hour") && (
                  <span className="error-custom">
                    {getFieldError("from_hour")}
                  </span>
                )}
              </div>

              <div className={`${Style.spacer_icon}`}>
                <span className="pro-px-3 pro-d-flex pro-items-center">
                  <span className="material-symbols-outlined x4">remove</span>
                </span>
              </div>
              <div className={`${Style.time_item}`}>
                <label
                  htmlFor=""
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  To Hour
                </label>
                <TimePicker
                  value={formik.values.to_hour || null}
                  onChange={(newValue) => {
                    formik.setFieldValue("to_hour", newValue);
                  }}
                  className="time-picker"
                  disabled={!formik.values.from_hour}
                />
                {getFieldError("to_hour") && (
                  <span className="error-custom">
                    {getFieldError("to_hour")}
                  </span>
                )}
              </div>
              <div className={`${Style.spacer_icon} pro-ps-3`}>
                <div className="form-check form-switch pro-mb-0 pro-ms-auto">
                  <input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    role="switch"
                    id="time_filter"
                    checked={formik.values.time_filter === 1}
                    onChange={() => {
                      const newValue = formik.values.time_filter === 1 ? 2 : 1;
                      formik.setFieldValue("time_filter", newValue);
                      if (newValue === 2) {
                        formik.setFieldValue("from_hour", null);
                        formik.setFieldValue("to_hour", null);
                      }
                    }}
                  />
                </div>
              </div>
            </LocalizationProvider>
          </div>
        </div>
        <div className="input-wrap pro-mb-4">
          <label
            htmlFor="splited_discount"
            className="pro-font-sm pro-mb-1 pro-fw-medium"
          >
            Splited Discount
          </label>
          <Select
            id="splited_discount"
            name="splited_discount"
            placeholder={"Select"}
            className={`pro-input lg ${
              getFieldError("splited_discount") && " error"
            }`}
            classNamePrefix="pro-input"
            options={splitedDiscountOptions}
            value={
              splitedDiscountOptions.find(
                (item) => item.id === formik?.values?.splited_discount
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("splited_discount")}
            onChange={(selected) => {
              formik.setFieldValue("splited_discount", selected.id || null);
            }}
            menuPlacement="auto"
          />
          {getFieldError("splited_discount") && (
            <span className="error-text">
              {getFieldError("splited_discount")}
            </span>
          )}
        </div>

        <Input
          label={"Offer Limit"}
          type="text"
          id="offer_limit"
          name="offer_limit"
          className={`pro-input lg ${getFieldError("offer_limit") && "error"}`}
          {...formik.getFieldProps("offer_limit")}
          error={getFieldError("offer_limit")}
          errorMessage={getFieldError("offer_limit")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <Input
          label={"Minimum Cart Amount"}
          type="text"
          id="min_cart_amount"
          name="min_cart_amount"
          className={`pro-input lg ${
            getFieldError("min_cart_amount") && "error"
          }`}
          {...formik.getFieldProps("min_cart_amount")}
          error={getFieldError("min_cart_amount")}
          errorMessage={getFieldError("min_cart_amount")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];

            const isNumber = /^[0-9]$/.test(e.key);
            const isDecimal = e.key === ".";
            const alreadyHasDecimal = e.currentTarget.value.includes(".");

            if (
              !isNumber &&
              !allowedKeys.includes(e.key) &&
              (!isDecimal || alreadyHasDecimal)
            ) {
              e.preventDefault();
            }
          }}
        />
        <Input
          label={"Maximum Cart Amount"}
          type="text"
          id="max_cart_amount"
          name="max_cart_amount"
          className={`pro-input lg ${
            getFieldError("max_cart_amount") && "error"
          }`}
          {...formik.getFieldProps("max_cart_amount")}
          error={getFieldError("max_cart_amount")}
          errorMessage={getFieldError("max_cart_amount")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];

            const isNumber = /^[0-9]$/.test(e.key);
            const isDecimal = e.key === ".";
            const alreadyHasDecimal = e.currentTarget.value.includes(".");

            if (
              !isNumber &&
              !allowedKeys.includes(e.key) &&
              (!isDecimal || alreadyHasDecimal)
            ) {
              e.preventDefault();
            }
          }}
        />
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Bin Series
          </label>
          <Select
            id="bin_number_limit"
            name="bin_number_limit"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("bin_number_limit") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.number_limits ?? []}
            value={
              offersBasicData?.data?.number_limits?.find(
                (item) => item?.id === formik?.values?.bin_number_limit
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("bin_number_limit")}
            onChange={(e) =>
              formik?.setFieldValue("bin_number_limit", e?.id || null)
            }
            menuPlacement="auto"
          />
          {getFieldError("bin_number_limit") && (
            <span className="error-text">
              {getFieldError("bin_number_limit")}
            </span>
          )}
        </div>
        <Input
          label={"Bin Series Start"}
          type="text"
          id="bin_start"
          name="bin_start"
          className={`pro-input lg ${getFieldError("bin_start") && "error"}`}
          {...formik.getFieldProps("bin_start")}
          error={getFieldError("bin_start")}
          errorMessage={getFieldError("bin_start")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <Input
          label={"Bin Series End"}
          type="text"
          id="bin_end"
          name="bin_end"
          className={`pro-input lg ${getFieldError("bin_end") && "error"}`}
          {...formik.getFieldProps("bin_end")}
          error={getFieldError("bin_end")}
          errorMessage={getFieldError("bin_end")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Apple Pay Bin
          </label>
          <Select
            id="apple_bin_number_limit"
            name="apple_bin_number_limit"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("apple_bin_number_limit") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.number_limits ?? []}
            value={
              offersBasicData?.data?.number_limits?.find(
                (item) => item?.id === formik?.values?.apple_bin_number_limit
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("apple_bin_number_limit")}
            onChange={(e) =>
              formik?.setFieldValue("apple_bin_number_limit", e?.id || null)
            }
            menuPlacement="auto"
          />
          {getFieldError("apple_bin_number_limit") && (
            <span className="error-text">
              {getFieldError("apple_bin_number_limit")}
            </span>
          )}
        </div>
        <Input
          label={"Apple Pay Bin Series Start"}
          type="text"
          id="apple_pay_bin_start"
          name="apple_pay_bin_start"
          className={`pro-input lg ${
            getFieldError("apple_pay_bin_start") && "error"
          }`}
          {...formik.getFieldProps("apple_pay_bin_start")}
          error={getFieldError("apple_pay_bin_start")}
          errorMessage={getFieldError("apple_pay_bin_start")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <Input
          label={"Apple Pay Bin Series End"}
          type="text"
          id="apple_pay_bin_end"
          name="apple_pay_bin_end"
          className={`pro-input lg ${
            getFieldError("apple_pay_bin_end") && "error"
          }`}
          {...formik.getFieldProps("apple_pay_bin_end")}
          error={getFieldError("apple_pay_bin_end")}
          errorMessage={getFieldError("apple_pay_bin_end")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <Input
          label={"Discount"}
          type="text"
          id="discount"
          name="discount"
          className={`pro-input lg ${getFieldError("discount") && "error"}`}
          {...formik.getFieldProps("discount")}
          error={getFieldError("discount")}
          errorMessage={getFieldError("discount")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Transaction Period
          </label>
          <Select
            id="transaction_period"
            name="transaction_period"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("transaction_period") && " error"
            }`}
            classNamePrefix="pro-input"
            options={offersBasicData?.data?.offer_periods ?? []}
            value={
              offersBasicData?.data?.offer_periods?.find(
                (item) => item?.id === formik?.values?.transaction_period
              ) || null
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("transaction_period")}
            onChange={(e) => handleTransactionPeriodChange(e)}
            menuPlacement="auto"
          />
          {getFieldError("transaction_period") && (
            <span className="error-text">
              {getFieldError("transaction_period")}
            </span>
          )}
        </div>
        <Input
          label={"Transaction Limit"}
          type="text"
          id="transaction_limit"
          name="transaction_limit"
          className={`pro-input lg ${
            getFieldError("transaction_limit") && "error"
          }`}
          {...formik.getFieldProps("transaction_limit")}
          error={getFieldError("transaction_limit")}
          errorMessage={getFieldError("transaction_limit")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
        <div className="input-wrap pro-mb-4">
          <label className="pro-font-sm pro-mb-1 pro-fw-medium">
            Award Loyalty Point
          </label>
          <div className="pro-d-flex pro-gap-4">
            <div className="pro-check-box">
              <input
                type="radio"
                className="pro-check"
                id="award_loyalty_point_yes"
                name="award_loyalty_point"
                checked={formik.values.award_loyalty_point === 1}
                onChange={() =>
                  formik.setFieldValue("award_loyalty_point", 1)
                }
              />
              <label
                htmlFor="award_loyalty_point_yes"
                className="pro-check-label"
              >
                Yes
              </label>
            </div>
            <div className="pro-check-box">
              <input
                type="radio"
                className="pro-check"
                id="award_loyalty_point_no"
                name="award_loyalty_point"
                checked={formik.values.award_loyalty_point === 2}
                onChange={() =>
                  formik.setFieldValue("award_loyalty_point", 2)
                }
              />
              <label
                htmlFor="award_loyalty_point_no"
                className="pro-check-label"
              >
                No
              </label>
            </div>
          </div>
          {getFieldError("award_loyalty_point") && (
            <span className="error-text">
              {getFieldError("award_loyalty_point")}
            </span>
          )}
        </div>

        <div className="pro-check-box pro-py-2">
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={Boolean(formik.values?.status === 1) ?? false}
              onChange={(e) =>
                formik.setFieldValue("status", e?.target?.checked ? 1 : 2)
              }
            />
            <label htmlFor="default" className="pro-check-label">
              Status
            </label>
          </div>
        </div>

        <div
          className={`col-12 pro-d-flex pro-justify-end ${
            isStickyFooter && "offcanvas-footer-sticky-btns"
          }`}
        >
          <Button
            className={"pro-btn-link lg pro-px-5"}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>

          <Button
            className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
            type="submit"
            onClick={formik.handleSubmit}
            disabled={isCustomOfferCreate}
          >
            {!isEdit
              ? isCustomOfferCreate
                ? "Creating..."
                : "Create"
              : isCustomOfferCreate
              ? "Updating..."
              : "Update"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateOffer;
